import { useState } from 'react';

import type { QltUploadFile } from '../../api/repository/upload';
import { MediaOverlay } from './MediaOverlay';

export function ImageOverlay({ image, onClose }: { image: QltUploadFile | null; onClose: () => void }) {
  const known = image && image.width && image.height ? image.width / image.height : 0;
  const [loaded, setLoaded] = useState(0);
  if (!image) return null;
  // the card keeps the picture's own ratio once it is known, so a corner resize never letterboxes it
  const aspect = known || loaded;
  return (
    <MediaOverlay title={image.name} fit={aspect > 0 ? aspect : 'fill'} onClose={onClose}>
      <div className={aspect > 0 ? 'image-overlay image-overlay--fitted' : 'image-overlay'}>
        <img src={image.url} alt={image.name} onLoad={(event) => { const node = event.currentTarget; if (node.naturalHeight > 0) setLoaded(node.naturalWidth / node.naturalHeight); }} />
      </div>
    </MediaOverlay>
  );
}
